<template>
  <div style="padding-top: 0px; padding-left:0px;">
  <v-toolbar  flat  dense >
    <v-toolbar-title>{{taskTitle}}&nbsp;</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn  color="blue" @click="save" :disabled="error != '' || task.topic == undefined || task.topic == '' || task.responsible.length == 0">save</v-btn>
    <v-icon @click="close">mdi-close</v-icon>
  </v-toolbar>
  <v-card>
    <v-card-text>
      <div class="time-diff-err"> {{error}} </div>
      <v-text-field style="padding: 10px;" label="Topic" :disabled="!fullAccess" v-model="task.topic"></v-text-field>
      <v-container fluid align-start >
        <VueCtkDateTimePicker style="padding-bottom: 20px;" v-if="fullAccess"
          label="Set Start Time"
          v-model="startDate"
          output-format="llll"
          :dark="dark"
        ></VueCtkDateTimePicker>
        <v-label v-else>Start: {{startDate.format("YYYY-MM-DD hh:mm:ss A")}} </v-label>
        <VueCtkDateTimePicker style="padding-bottom: 20px;" v-if="fullAccess"
          label="Set End Time"
          v-model="endDate"
          output-format="llll"
          :dark="dark"
        ></VueCtkDateTimePicker>
        <div v-else style="padding-bottom: 10px;"><v-label >End  : {{endDate.format("YYYY-MM-DD hh:mm:ss A")}} </v-label></div>
        <v-select v-model="task.priority" :items="priorities" :disabled="!fullAccess"
          label="Priority" />
        <v-select v-model="task.status" :items="statusOptions"
          label="Status" />
        <v-select :disabled="!fullAccess" v-model="task.responsible" :items="employees" label="Assigned To:" multiple item-text="name" item-value="id"/>
        <v-select :disabled="!fullAccess" v-model="task.visibility" :items="employees" label="Visible To:" multiple item-text="name" item-value="id"/>
        <v-textarea v-if="!fullAccess" label="Additional Comments"  v-model="addl"></v-textarea>
        <v-textarea label="Details" :disabled='!fullAccess' v-model="task.desc"></v-textarea>
      </v-container>
    </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { sync } from "vuex-pathify"
import moment from 'moment'
import axiosInstances from "@/../../coreui/server/axiosInstances"
import dateRangePicker from '@/../../coreui/library/DateRangePicker'
export default {
  props: ['taskInit', 'mode', 'users'],
  components: {
    dateRangePicker
  },
  data: () => ({
    addl: '',
    taskTitle: 'Create New Task',
    task: {},
    startDate: moment(),
    endDate: moment(),
    error: '',
    fullAccess: true,
    newTask: true,
    priorities: [
      'Low',
      'Medium',
      'High',
      'Critical'
    ],
    statusOptions: [
      'Assigned',
      'Completed',
      'In Progress',
      'Blocked',
      'Abandoned',
      'Postponed'
    ],
    employees: [],
  }),
  computed: {
    dark: sync("misc/dark"),
    origLoggedinUser: sync('login/origLoggedinUser')
  },
  watch: {
    startDate() {
      this.checkDatesAreValid()
    },
    endDate() {
      this.checkDatesAreValid()
    }
  },
  methods: {
    close () {
      this.$emit('update:closeTask', {'op': 'close'})
    },
    async save () {
      this.task.start =  moment(this.startDate).utc().format()
      this.task.end = moment(this.endDate).utc().format()
      this.task.creator = this.origLoggedinUser._id
      if (this.newTask) {
        console.log('new: ', this.task)
        await axiosInstances.origApiServer.post('/dt/v1/fac_calendar', this.task)
      } else {
        if (!this.fullAccess && this.addl != '') {
          this.task.desc = this.origLoggedinUser.firstname + ' ' + this.origLoggedinUser.lastname + ' on ' + 
            moment().format("YYYY-MM-DD hh:mm:ss A") + ' added: \n'
            + this.addl + '\n'  + this.task.desc  || ''    
          }
        await axiosInstances.origApiServer.patch('/dt/v1/fac_calendar/'+this.task._id, this.task)
      }
      this.$emit('update:closeTask', {'op': 'save'})
      console.log('emiting ', {'op': 'save'})
    },
    checkDatesAreValid () {
      if (moment(this.endDate).isAfter(this.startDate)) {
        this.error = ''
      } else if (this.fullAccess){
        this.error = 'End date must be after start date'
      }
    }
  },
  async mounted () {
    if (!this.taskInit || Object.keys(this.taskInit).length == 0) {
      let task = {}
      task.priority = 'Low'
      task.status = 'Assigned'
      task.topic = null
      task.desc = null
      task.responsible = []
      this.fullAccess = true
      this.newTask = true
      this.taskTitle = 'Create New Task'
      this.task = task
    } else {
      this.task = Object.assign({}, this.taskInit)
      this.startDate = moment(this.task.start) 
      this.endDate = moment(this.task.end) 
      if (this.task.creator == this.origLoggedinUser._id) {
        this.fullAccess = true
      } else {
        this.fullAccess = false
      }
      this.newTask = false
      this.taskTitle = 'Update Task'
    }
    console.log(this.task)
    // get auth users list
    let res = await axiosInstances.loginServer.get('/dt/v1/users?orgonly&active=yes&return=firstname&return=lastname')
    this.employees = []
    if (res != null && res.data != null) res.data.forEach((x) => {
      this.employees.push({
        'id': x['_id'],
        'name': x['firstname'] + ' ' + x['lastname']
      })
    })
  }
}
</script>
<style >
.time-diff-err {
    white-space: pre;
    color: red;
  }
</style>
